import accountsSection01Content from './content/accounts-section01';
import accountsSection02Content from './content/accounts-section02';
import accountsSection03Content from './content/accounts-section03';
import accountsSection04Content from './content/accounts-section04';
import accountsSection05Content from './content/accounts-section05.json';

const accountsMock = {
    layoutType: 2,
    data: {
        name: 'accounts',
        layoutType: 2,
        areasList: [
            {
                id: 'accounts-page-area',
                name: 'Content',
                content: accountsSection01Content,
            },
            {
                id: 'accounts-page-area',
                name: 'Content',
                componentName: 'Comp:AccountsTypes',
                content: JSON.stringify(accountsSection05Content),
            },
            {
                id: 'accounts-page-area',
                name: 'Content',
                content: accountsSection04Content,
            },
            {
                id: 'accounts-page-area',
                name: 'Content',
                content: accountsSection03Content,
            },
        ],
    },
};

export default accountsMock;
